export enum ErrorCodes {
  NoSamplesAdded = 'error_no_samples_added',
  NoTestRequirementsAdded = 'error_no_requirements_added',
  PlannedTestingDateOutsideBoundaries = 'error_planned_testing_date_outside_boundaries',
  NoStampsAdded = 'error_no_stamps_selected'
}
